import React from 'react'

const CarboonFootprintDisclaimer = () => {
  return (
    <tr>
      <td className="border-top-0" colSpan={4}>
        <span className='font-italic' style={{ fontSize: "12px" }}>
          *Compared to traditional PVC, PU, silicone based coated fabrics – Data
          derived from the EPD of Cassora collection, developed using the same
          material composition and product processes as Avani.
        </span>
      </td>
    </tr>
  );
}

export default CarboonFootprintDisclaimer